"use client";

import { isValidJSON } from "@/lib/json";
import { puckConfig } from "@/lib/puck";
import { BlogType } from "@/types/blog.type";
import { Render } from "@measured/puck";
import "@measured/puck/puck.css";

export default function Content({ blog }: { blog: BlogType }) {
  return (
    <div className="py-4">
      {blog.body_html && (
        <Render
          config={puckConfig}
          data={isValidJSON(blog.body_html) ? JSON.parse(blog.body_html) : {}}
        />
      )}
    </div>
  );
}
